import { Outlet } from "react-router-dom";

import { Metadata } from "@/common/components/metadata/metadata";
import { PWAInstaller } from "@/common/components/pwa-installer/pwa-installer";
import {
  Autoclose,
  SidebarProvider,
} from "@/common/providers/sidebar-provider/sidebar-provider";

const Root = ({ children }: React.PropsWithChildren) => {
  return (
    <SidebarProvider>
      <Autoclose>
        <Metadata />
        <PWAInstaller />
        <Outlet />
        {children}
      </Autoclose>
    </SidebarProvider>
  );
};

export { Root };
